


































































































































import Vue from 'vue';
import Validation from '../../mixins/validation';
import Api from '../../mixins/api';
import axios from 'axios';
import Helpers from '@/mixins/helpers';
import FieldDropdown from '@/components/dumb/FieldDropdown.vue';

// import Analytics from '../../mixins/analytics';

export default Vue.extend({
	name: 'FieldAddress', 
	props: {
		value: Object
	},
	components: {
		FieldDropdown
	},
	mixins: [Validation, Api],
	data: () => ({
		states: [
			'ACT',
			'NSW',
			'NT',
			'QLD',
			'SA',
			'TAS',
			'VIC', 
			'WA'
		],
		form: {
			postcode: {
				value: '',
				isValid: false
			},
			address: {
				value: {
					'formatted_address': ''
				}, 
				isValid: false, 
				isSensisError: false,
				isLoading: true,
				isValidating: false,
				showIndividualFields: false,
				search: '',
				addresses: []
			},
			sa1Code: {
				value: '', 
				isValid: false
			}, 
			subPremise: {
				value: '',
				isValid: false
			},
			unitNo: {
				value: '', 
				isValid: false
			},
			streetNo: {
				value: '', 
				isValid: false
			},
			streetName: {
				value: '', 
				isValid: false
			},
			streetAddress: {
				value: '', 
				isValid: false
			},
			streetType: {
				value: '', 
				isValid: false
			},
			suburb: {
				value: '', 
				isValid: false
			},
			state: {
				value: '', 
				isValid: false
			}
		}
	}), 
	computed: {
		addressRules(): boolean {
			return this.form.address.isValid || this.form.address.showIndividualFields;
		},
		postcodeRules(): Array<Function> {
			return [Validation.isPostcode];
		}, 
		addressNoDataText(): string {
			if (this.form.address.search && this.form.address.search.length > 4){
				return this.form.address.isLoading ? 'Searching...' : 'Could not find your address.';
			}
			else {
				return '';
			}
		},
		isAddressValid(): boolean {
			return !!this.form.address.value && !!this.form.address.value['formatted_address']; 
		}
	}, 
	methods: {
		handleStateInput($event: any): void {
			this.form.state.isValid = !!this.form.state.value;
			this.handleManualFieldInput();
			this.handleFieldUpdate('state', $event);
		},
		handleFieldUpdate(fieldName: string, isValid: boolean): void {
			Helpers.clog(fieldName); // isValid
		}, 
		handlePostcodeInput(){
			this.setFieldValid(this.form.postcode, this.postcodeRules); 
			!this.form.address.isLoading && !this.form.address.showIndividualFields && this.clearAddress();
			// this.$emit('postcodeInput', this.form.postcode.isValid ? this.form.postcode.value : '');
		},
		handlePostcodeBlur(){
			this.setFieldValid(this.form.postcode, this.postcodeRules);
			this.$emit('postcodeBlur', Validation.isPostcode(this.form.postcode.value));
			// !this.form.postcode.isValid && this.$emit('blur', Validation.isPostcode(this.form.postcode.value));
		},
		isManualValid(v: string): boolean {
			return !this.form.address.showIndividualFields || !!v;
		},
		handleClearClick(){
			// Analytics.sendButtonClick('clear address');
			this.clearAddress();
		},
		// handleAddressTab(e: any): void {	
		// 		console.log('address tab begin');

		// 	if (!e.shiftKey && this.form.address.value && !!this.form.address.value.formatted_address){
		// 		console.log('address tab if');
		// 		this.$emit('blur', this.form.address.isValid);
		// 	}
		// },
		handleManualFieldInput(): void {
			this.form.address.value = {'formatted_address': ''};
			this.form.address.isValid = false;
			this.emitForm();
		},
		setFieldValid(o: any, r: Array<Function>): void {
			const e = Validation.isFieldValid(o.value, r);
			o.isValid = (e && typeof(e) == 'boolean');
		}, 
		handleAddressSearchInput(s: string): void {
			const currentAddress = this.form.address.value ? this.form.address.value.formatted_address : '';
			if (s && s.length > 4 && s != currentAddress && this.form.postcode.isValid){	
				const search = s.replace(this.form.postcode.value, '') + ' ' + this.form.postcode.value;
				this.searchSensis(search);
			}
		}, 
		handleAddressInput(o: any): void {
			if (o && o.search_result_id){
				const url = Api.returnSensisResultURL(o.search_result_id);
				this.form.address.isValidating = true;
				url && axios.get(url)
				.then((response) => {
					this.setAddress(response.data.result);
					this.form.address.isValidating = false;
				})
				.catch((response) => {
					this.setSensisError(response);
					this.form.address.isValidating = false;
				});
			}
		},
		setAddress(o: any): void{
			if (o){
				this.form.postcode.value = o.postcode || '';
				this.form.unitNo.value = o.subpremise || '';
				this.form.sa1Code.value = o.sa1_7dig || ''
				this.form.subPremise.value = o.subpremise || ''
				this.form.streetNo.value = o.street_number || '';
				this.form.streetName.value = o.street_name || '';
				this.form.streetAddress.value = o.street_address || '';
				this.form.streetType.value = o.street_type || '';
				this.form.suburb.value = o.suburb || '';
				this.form.state.value = o.state || '';

				this.form.postcode.isValid = true;
				this.form.address.isValid = true;
				this.form.unitNo.isValid = true;
				this.form.sa1Code.isValid = true;
				this.form.subPremise.isValid = true;
				this.form.streetNo.isValid = true;
				this.form.streetName.isValid = true;
				this.form.streetAddress.isValid = true;
				this.form.streetType.isValid = true;
				this.form.suburb.isValid = true;
				this.form.state.isValid = true;
				this.emitForm();
				this.$emit('blur', true);
			}
			else {
				this.clearAddress();
			}
		},
		clearAddress(): void {
			this.form.address.value = { 'formatted_address': '' };
			this.form.unitNo.value = '';
			this.form.streetNo.value = '';
			this.form.sa1Code.value = ''
			this.form.subPremise.value = ''
			this.form.streetName.value = '';
			this.form.streetAddress.value = '';
			this.form.streetType.value = '';
			this.form.suburb.value = '';
			this.form.state.value = '';
			this.form.address.isValid = false;
			this.form.unitNo.isValid = false;
			this.form.sa1Code.isValid = false;
			this.form.subPremise.isValid = false;
			this.form.streetNo.isValid = false;
			this.form.streetName.isValid = false;
			this.form.streetAddress.isValid = false;
			this.form.streetType.isValid = false;
			this.form.suburb.isValid = false;
			this.form.state.isValid = false;

			// this.$emit('input', {...this.form});
			this.emitForm();
			this.$emit('blur', false);
		},
		searchSensis(s: string): void {
			(window as any).sensisRateLimitTimeout && clearTimeout((window as any).sensisRateLimitTimeout);
			this.form.address.isSensisError = false;
			this.form.address.isLoading = true;
			this.form.address.isValid = false;
			this.form.address.showIndividualFields = false;
			(window as any).sensisRateLimitTimeout = window.setTimeout(() => {
				Validation.clog('Getting sensis results...');
				const url = Api.returnSensisURL(s);
				Vue.set(this.form.address, 'addresses', []);
				url && axios.get(url)
				.then((response) => {
					Validation.clog(response);
					const addresses = response.data.results.slice(0, 10).map((o: any) => {
						return { text: o.formatted_address, value: o };
					});
					Vue.set(this.form.address, 'addresses', addresses);
					this.form.address.isLoading = false;
				})
				.catch((response: any) => {
					this.setSensisError(response);
				});
			}, 500);
		}, 
		setSensisError(response: any): void {
			console.error('Sensis error');
			Validation.clog(response);
			(this.$refs.address as any).blur();
			this.form.address.isSensisError = true;
			this.form.address.showIndividualFields = true;
			this.form.address.isLoading = false;
			this.$nextTick(() => {
				(this.$refs.unitNo as any).focus();
			});
			// this.sendFormError('sensis failure - first call')
		}, 
		emitForm(): void {
			this.$emit('input', {
				postcode: this.form.postcode.value,
				address: this.form.address.value.formatted_address,
				unitNo: this.form.unitNo.value,
				streetNo: this.form.streetNo.value,
				sa1Code: this.form.sa1Code.value,
				subPremise: this.form.subPremise.value,
				streetName: this.form.streetName.value,
				streetAddress: this.form.streetAddress.value,
				streetType: this.form.streetType.value,
				suburb: this.form.suburb.value,
				state: this.form.state.value
			});
		}
	}, 
	mounted(){
		// todo prepopulate
		if (this.value && this.value.address){
			(this.form.address.addresses as any).push({
				text: this.value.address, 
				value: {
					'formatted_address': this.value.address
				}
			});
			this.form.address.value['formatted_address'] = this.value.address;
			this.form.postcode.value = this.value.postcode;
			this.form.unitNo.value = this.value.unitNo;
			this.form.streetNo.value = this.value.streetNo;
			this.form.streetName.value = this.value.streetName;
			this.form.streetAddress.value = this.value.streetAddress;
			this.form.streetType.value = this.value.streetType;
			this.form.suburb.value = this.value.suburb;
			this.form.state.value = this.value.state;

			this.form.address.isValid = true;
			this.form.postcode.isValid = true;
			this.form.unitNo.isValid = true;
			this.form.streetNo.isValid = true;
			this.form.streetName.isValid = true;
			this.form.streetAddress.isValid = true;
			this.form.streetType.isValid = true;
			this.form.suburb.isValid = true;
			this.form.state.isValid = true;
		}
		this.form.address.isLoading = false;
	}
})
